import { FormikProvider, useFormik } from "formik";
import { useEffect, useState } from "react";
import { VehiclesHistoricalRow } from "../fields-upload/VehiclesHistoricalRow";
import { formatDateAndTime } from "../../../../../common/helpers/date.helpers";
import { IMaintenanceVisualRecord } from "../../../../../types/maintenance-visual-record.type";

type CardDeliveredProps = {
  data: IMaintenanceVisualRecord;
  onClick?: () => void
  showDeliveredDetails?: boolean;
}

export default function CardStartMaintenance(props: CardDeliveredProps) {

  const [, setvehicleId] = useState<string | null>(null);
  const formik = useFormik({
    initialValues: {
      startMaintenance: [
        props.data.photosMaintenance[0].startMaintenance.find(startMaintenance => startMaintenance.type === 'Odômetro'),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ] as any,
      // outras propriedades inicializadas aqui
    },
    onSubmit: (values) => {values},
    // outras opções do Formik aqui
  });

  const initialDateAt = props.data.createdAt ? formatDateAndTime(props.data.createdAt.toString()) : '';

  useEffect(() => {
    setvehicleId(props.data.vehicleId);
  }, [props.data]);
  
  return (
    <FormikProvider value={formik}>
      <div className="flex flex-col z-0 items-center bg-gray2/20 m-1 p-1 pt-4 rounded shadow-md border-b border-gray2 cursor-pointer overflow-hidden h-64" onClick={props.onClick}>
        {formik.values?.startMaintenance?.map((doc, index) => (
          <div key={index} className={`flex flex-col space-y-2 p-3 my-0 rounded ${index % 2}`}>
            <VehiclesHistoricalRow
              name={`startMaintenance.${index}`}
              initialData={doc || {}}
              prefix="devolucao"
              vehicleId={props.data.vehicleId}
            />
          </div>
        ))}

        <p className="text-[.9rem] text-black mx-auto">Iniciado em:</p>
        <p className="text-[.9rem] text-black mx-auto">{initialDateAt}</p>
      </div>
    </FormikProvider>
  )
}



